import React from 'react';
import { Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center text-center px-4 bg-primary-600">
      {/* Logo Icon */}
      <div className="inline-flex items-center justify-center w-16 h-16 mb-8 rounded-2xl bg-white/10 backdrop-blur-sm">
        <Zap className="h-8 w-8 text-white" />
      </div>

      {/* Main Heading */}
      <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
        Transforme Sua Estratégia de Conteúdo
      </h1>

      {/* Subheading */}
      <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto">
        Gere ideias envolventes, otimize seu fluxo de trabalho e impulsione sua presença online com Kontty.
      </p>

      {/* CTA Button */}
      <Link
        to="/cadastro"
        className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-primary-600 bg-white rounded-full hover:bg-primary-50 transition-all transform hover:scale-105 shadow-lg hover:shadow-xl"
      >
        Começar Agora
        <Zap className="ml-2 h-5 w-5" />
      </Link>
    </div>
  );
}